module.exports = __webpack_public_path__ + "media/long_kh.4ccddc12.mp3";